import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Entity } from '@shapeable/types';
import { breakpoints, theme, ColorTokens } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { Button, useLang, useModal } from '@shapeable/ui';
import { SubscribeIframe } from './subscribe-iframe';
import { PlusIconGlyph } from '@shapeable/icons';
import { GOLD_ORANGE } from '../../theme';

const cls = classNames('entity-feature-grid-iframe-button');

// -------- Types -------->

// -------- Props -------->

export type EntityFeatureGridIframeButtonProps = Classable & HasChildren & { 
  entity?: Entity;
};

export const EntityFeatureGridIframeButtonDefaultProps: Omit<EntityFeatureGridIframeButtonProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const SubscribeButtonStyles = breakpoints({
  base: css`
    text-transform: uppercase;
    transition: box-shadow 0.3s ease, transform 0.3s ease;
    &:hover {
      box-shadow: 1px 5px 5px rgba(0, 0, 0, 0.2);
      transform: scale(1.02);
    }
  `,
});

const ModalStyles = breakpoints({
  base: css`
    
  `,
});


// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    SubscribeButton: styled(Button)`${SubscribeButtonStyles}`,
    Modal: styled(SubscribeIframe)`${ModalStyles}`,
};

export const EntityFeatureGridIframeButton: Shapeable.FC<EntityFeatureGridIframeButtonProps> = (props) => {
  const { className, children, entity } = props;

  const t = useLang();
  const modal = useModal();

  const handleModalClick = () => {
    modal?.show(<SubscribeIframe />, { color: '#000000', title: 'Subscribe', opacity: 0.5 });
  };
  
  return (
    <My.Container className={cls.name(className)}>
      <My.SubscribeButton
        variant='slim'
        borderStyle='solid'
        shape='rounded'
        isReversed
        reversedIcon={PlusIconGlyph}
        colors={{ fill: 'canvas', text: 'canvas', border: GOLD_ORANGE, background: GOLD_ORANGE }}
        onClick={handleModalClick}
      >
        {t('subscribe')}
      </My.SubscribeButton>
    </My.Container>
  )
};

EntityFeatureGridIframeButton.cls = cls;